import {Injectable} from '@angular/core';
import {PrivacyStore} from './privacy.store';
import {Observable} from 'rxjs';
import {ConstantsStore} from '../constants.store';
import {ApiService} from '../api-service';
import {Disclaimer} from '../../../models/disclaimer';

@Injectable({
  providedIn: 'root'
})
export class PrivacyService {

  constructor(
    private store: PrivacyStore,
    private constants: ConstantsStore,
    private apiService: ApiService
  ) { }


  public get(): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.apiGet()
        .toPromise()
        .then(
          (res: Disclaimer[]) => {          
            this.store.disclaimers = res;
            resolve(true);
          },
          (error: any) => reject(error)
        );
    });
  }


  updateDisclaimerInDb(disclaimer: Disclaimer): Observable<any> {
    return new Observable(observer => {
      this.apiPut(disclaimer)
        .subscribe(
          () => {
            observer.next();
          },
          error => {
            observer.error(error);
          }
        );
    });
  }

  /* Actions in store */
  updateDisclaimerInStore(disclaimer: Disclaimer): void {
    this.store.disclaimers.forEach(d => {
      if (d.id === disclaimer.id) {
        d.description = disclaimer.description;
      }
    });
  }
  getPrivacyDisclaimer() {
    const disclaimerData = {
      description: '',
      exists: false
    };
    this.store.disclaimers.forEach(d => {
      if (d.id === 1) {
        disclaimerData.description = d.description;
        disclaimerData.exists = true;
      }
    });
    return disclaimerData;
  }

  getPrivacyInRegistrationDisclaimer() {
    const disclaimerData = {
      description: '',
      exists: false
    };
    this.store.disclaimers.forEach(d => {
      if (d.id === 2) {
        disclaimerData.description = d.description;
        disclaimerData.exists = true;
      }
    });
    return disclaimerData;
  }

  /* API calls */
  private apiGet() {
    return this.apiService.get<Disclaimer[]>(this.constants.privacyUrl);
  }

  private apiPut(disclaimer: Disclaimer) {
    return this.apiService.put<Disclaimer>(this.constants.privacyUrl, disclaimer);
  }
}
